import React from 'react';
import { Box } from '@material-ui/core';
import { Theme } from '@orijinworks/frontend-commons';
import ExportPlanModal from '../../../../components/export-plan-modal';
import { CasePlanDetailHeader } from '../CasePlanDetailHeader';
import { CasePlanDetailsSections } from '../CasePlanDetailsSections';

export function CasePlanDetailsContent({
  classes,
  cardProps,
  sections,
  isViewOnly = false,
  isSectionsLoading,
  collapsedSections,
  onBack,
  onToggleCollapse,
  onAddWidget,
  onAddSection,
  onEditorsClick,
  onExportClick,
  isExportOpen,
  onExportClose,
  onExportSubmit,
}) {
  return (
    <Theme>
      <Box className={classes.page} role="main" aria-label="Case Plan Details">
        <CasePlanDetailHeader
          cardProps={cardProps}
          isSectionsLoading={isSectionsLoading}
          onBack={onBack}
          onEditorsClick={isViewOnly ? undefined : onEditorsClick}
          onExportClick={onExportClick}
        />
        <CasePlanDetailsSections
          isViewOnly={isViewOnly}
          isSectionsLoading={isSectionsLoading}
          sections={sections}
          collapsedSections={collapsedSections}
          onToggleCollapse={onToggleCollapse}
          onAddWidget={onAddWidget}
          onAddSection={onAddSection}
        />
        <ExportPlanModal
          open={isExportOpen}
          sections={sections}
          onClose={onExportClose}
          onExport={onExportSubmit}
        />
      </Box>
    </Theme>
  );
}
